'use client';

import shareimg from '@/assets/images/product/share.svg';
import { useStyle } from '@/classify';
import Icon from '@/components/Icon';
import useIsMobile from '@/hooks/use-is-mobile';
import Image from 'next/image';
import { useEffect, useState } from 'react';
import { X as CloseIcon } from 'react-feather';
import { useIntl } from 'react-intl';
import type { ProductRoot } from '../../types/product';
import defaultClasses from './share-with.module.css';

export const ShareWith = ({
  product,
  showShareBtn,
  shareBtn,
}: {
  product: ProductRoot;
  shareBtn: boolean;
  showShareBtn: () => void;
}) => {
  const classes = useStyle(defaultClasses);
  const isMobile = useIsMobile();

  const { locale } = useIntl();
  const [origin, setOrigin] = useState('');

  useEffect(() => {
    setOrigin(globalThis.location.origin);
  }, []);
  const currentPrice = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: product.price.regularPrice.amount.currency,
  }).format(product.price.regularPrice.amount.value);

  return (
    <div className={classes.share}>
      {!isMobile ? <span>Share With：</span> : null}
      {shareBtn || !isMobile ? (
        <div>
          <div>
            {isMobile ? (
              <div className={classes.shareheader}>
                <span>share</span>
                <Icon
                  src={CloseIcon}
                  onClick={showShareBtn}
                />
              </div>
            ) : null}
            <ul className={shareBtn ? classes.sharelist : null}>
              <li>
                <a
                  href={
                    'http://www.facebook.com/sharer.php?u=' +
                    origin +
                    process.env.NEXT_PUBLIC_BASE_PATH +
                    '/' +
                    product.url_key +
                    '.html'
                  }
                />
              </li>
              <li>
                <a
                  href={
                    'http://pinterest.com/pin/create/button/?url=' +
                    origin +
                    process.env.NEXT_PUBLIC_BASE_PATH +
                    '/' +
                    product.url_key +
                    '.html&media=' +
                    process.env.NEXT_PUBLIC_MAGENTO_BACKEND_URL_IMAGE +
                    'media/catalog/product/' +
                    product?.media_gallery_entries[0]?.file +
                    '&description=' +
                    product.name +
                    currentPrice
                  }
                />
              </li>
              <li>
                <a
                  href={
                    'mailto:?subject=AW Bridal Real Wedding!&body=' +
                    product.name +
                    ' ' +
                    currentPrice +
                    '; ' +
                    origin +
                    process.env.NEXT_PUBLIC_BASE_PATH +
                    '/' +
                    product.url_key +
                    '.html'
                  }
                />
              </li>
              <li>
                <a
                  href={
                    'http://twitter.com/share?url=' +
                    origin +
                    process.env.NEXT_PUBLIC_BASE_PATH +
                    '/' +
                    product.url_key +
                    '.html'
                  }
                />
              </li>
            </ul>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export const ShareWithTriggerMobile = ({ showShareBtn }: { showShareBtn: () => void }) => {
  const isMobile = useIsMobile();

  if (!isMobile) {
    return null;
  }

  return (
    <Image
      className='absolute right-2.5 top-[15px] h-5 w-5'
      onClick={showShareBtn}
      src={shareimg}
      alt=''
    />
  );
};
